export default {
    'Eignung': [
        "geeignet", "nicht geeignet", "bedingt geeignet", "steht aus"
    ],
    'default': [
        "teilgenommen", "nicht teilgenommen", "abgelehnt", "steht aus"
    ]
}